import { Typography } from '@mui/material';

import { StyledCardContentEmptyState, StyledCardEmptyState } from './StyledCard';

export type CohortBuilderEmptyStateCardProps = {
  /**
   * @param {string} id - id of the entry, also used are the key
   */
  id: string;

  /**
   * @param {string} mainMessage - the main message
   */
  mainMessage: string;

  /**
   * @param {string} subMessage - the sub message
   */
  subMessage?: string;
};

export const CohortBuilderEmptyStateCard = ({
  id,
  mainMessage,
  subMessage,
}: CohortBuilderEmptyStateCardProps) => {
  return (
    <StyledCardEmptyState id={id} data-testid={`empty-state-card-${id}`}>
      <StyledCardContentEmptyState>
        <Typography data-testid={`empty-state-card-${id}-message-header`} variant="h5">
          {mainMessage}
        </Typography>
        <div style={{ height: '8px' }} />
        {subMessage && (
          <Typography data-testid={`empty-state-card-${id}-message-text`} variant="body1">
            {subMessage}
          </Typography>
        )}
      </StyledCardContentEmptyState>
    </StyledCardEmptyState>
  );
};
